import _typeof from '../../../../../node_modules/@babel/runtime/helpers/typeof.es.js';
import _defineProperty from '../../../../../node_modules/@babel/runtime/helpers/defineProperty.es.js';
import _classCallCheck from '../../../../../node_modules/@babel/runtime/helpers/classCallCheck.es.js';
import _createClass from '../../../../../node_modules/@babel/runtime/helpers/createClass.es.js';
import _inherits from '../../../../../node_modules/@babel/runtime/helpers/inherits.es.js';
import _possibleConstructorReturn from '../../../../../node_modules/@babel/runtime/helpers/possibleConstructorReturn.es.js';
import _getPrototypeOf from '../../../../../node_modules/@babel/runtime/helpers/getPrototypeOf.es.js';
import { zModalIncrementValue, zModalBackdrop, zModalMouseBackdrop, zModalInner, zModalInner2, zModalInner2MouseBackdrop, zModalInner3, zModalBase } from '@mgmresorts/wcl-styled';
import { isFixedStickyPortalWorkaroundEnabled, Transition } from '@mgmresorts/wcl-utils';
import focusTrap_1 from '../../../../../node_modules/focus-trap/index.es.js';
import React from 'react';
import Portal from '../../../../../node_modules/react-portal/es/PortalCompat.es.js';
import '../../BackdropContext/Backdrop.es.js';
import { BackdropContext } from '../../BackdropContext/BackdropContext.es.js';
import '../../../../../node_modules/@babel/runtime/helpers/toConsumableArray.es.js';
import '../../../../../node_modules/@babel/runtime/helpers/slicedToArray.es.js';
import { BodyScrollLockContext } from '../../BodyScrollLockContext/BodyScrollLockContext.es.js';
import '../../../../../node_modules/body-scroll-lock/lib/bodyScrollLock.esm.es.js';
import { EscKeyListenContext } from '../../EscKeyListenContext/EscKeyListenContext.es.js';
import { ZIndexContext } from '../../ZIndexContext/ZIndexContext.es.js';
import { ModalWrapperContext } from '../ModalWrapperContext.es.js';
import { StyledModalContainer, StyledBackdrop, StyledModalContainerInner, StyledModalContainerInner2, StyledInner2Backdrop, StyledModalContainerInner3 } from './ModalContainer.styles.es.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ModalContainer = function ModalContainer(props) {
  return /*#__PURE__*/React.createElement(BackdropContext.Consumer, null, function (_ref) {
    var show = _ref.show,
        hide = _ref.hide;
    return /*#__PURE__*/React.createElement(BodyScrollLockContext.Consumer, null, function (_ref2) {
      var enable = _ref2.enable,
          disable = _ref2.disable;
      return /*#__PURE__*/React.createElement(EscKeyListenContext.Consumer, null, function (_ref3) {
        var subscribe = _ref3.subscribe;
        return /*#__PURE__*/React.createElement(ModalContainerWithContextsProvided, Object.assign({
          backdropShow: show,
          backdropHide: hide,
          bodyScrollLockEnable: enable,
          bodyScrollLockDisable: disable,
          escKeyListenSubscribe: subscribe
        }, props));
      });
    });
  });
};

ModalContainer.selector = function (label) {
  return "Modal".concat(label ? ":".concat(label) : '');
};

ModalContainer.defaultProps = {
  open: true,
  backdrop: true,
  transitionDuration: 300,
  closeOnBackdropClick: true,
  closeOnEsc: true,
  width: '100%',
  height: '100%',
  verticalAlign: 'top',
  debug: false
};
var ModalContainerWithContextsProvided = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ModalContainerWithContextsProvided, _React$PureComponent);

  var _super = _createSuper(ModalContainerWithContextsProvided);

  function ModalContainerWithContextsProvided() {
    var _this;

    _classCallCheck(this, ModalContainerWithContextsProvided);

    _this = _super.apply(this, arguments);
    _this._wrapperRef = /*#__PURE__*/React.createRef();
    _this._dialogBeforeRef = /*#__PURE__*/React.createRef();
    _this._dialogAfterRef = /*#__PURE__*/React.createRef();
    _this._ModalWrapperContextValue = {
      nodeBefore: _this._dialogBeforeRef,
      nodeAfter: _this._dialogAfterRef
    };
    _this._outerRef = /*#__PURE__*/React.createRef();
    _this._innerRef = /*#__PURE__*/React.createRef();
    _this.state = {
      showModal: _this.props.open,
      zIndex: ModalContainerWithContextsProvided._zIndexCounter += zModalIncrementValue
    };

    _this._handleModalTransitionEnter = function () {
      _this._lockBodyScroll();

      _this._openBackdrop();

      _this._subscribeToEscKey();
    };

    _this._handleModalTransitionEntering = function () {
      _this._createFocusTrap();
    };

    _this._handleModalTransitionExit = function () {
      _this._closeBackdrop();

      _this._unsubscribeFromEscKey();

      _this._removeFocusTrap();
    };

    _this._handleModalTransitionExited = function () {
      _this._unlockBodyScroll();

      _this.setState({
        showModal: false
      });
    };

    _this._handleBackdropClick = function () {
      if (_this.props.closeOnBackdropClick) {
        if (_this.props.onClose) {
          _this.props.onClose();
        }
      }
    };

    return _this;
  }

  _createClass(ModalContainerWithContextsProvided, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.open !== this.props.open) {
        if (!this.state.showModal && this.props.open) {
          // eslint-disable-next-line react/no-did-update-set-state
          this.setState(function (_, props) {
            return {
              showModal: props.open
            };
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._unlockBodyScroll();

      this._closeBackdrop();

      this._unsubscribeFromEscKey();

      this._removeFocusTrap();
    }
  }, {
    key: "_isFullScreen",
    get: function get() {
      var _this$props = this.props,
          width = _this$props.width,
          height = _this$props.height;
      return width === '100%' && height === '100%';
    }
  }, {
    key: "_scrollContainerRef",
    get: function get() {
      return this._isFullScreen ? this._outerRef : this._innerRef;
    }
  }, {
    key: "_openBackdrop",
    value: function _openBackdrop() {
      var zIndex = this.state.zIndex;
      var backdropShow = this.props.backdropShow;

      if (!this._backdropId && this.props.backdrop) {
        var options = _objectSpread(_objectSpread({
          transitionDuration: _typeof(this.props.transitionDuration) === 'object' ? this.props.transitionDuration.enter : this.props.transitionDuration
        }, this.props.backdropOptions), {}, {
          zIndex: zModalBackdrop(zIndex),
          onClick: this.props.closeOnBackdropClick ? this.props.onClose : undefined
        });

        this._backdropId = backdropShow(options);
      }
    }
  }, {
    key: "_closeBackdrop",
    value: function _closeBackdrop() {
      if (this._backdropId) {
        var backdropHide = this.props.backdropHide;
        backdropHide(this._backdropId);
        delete this._backdropId;
      }
    }
  }, {
    key: "_lockBodyScroll",
    value: function _lockBodyScroll() {
      var _this$props2 = this.props,
          bodyScrollLockEnable = _this$props2.bodyScrollLockEnable,
          bodyScrollLockEnabled = _this$props2.bodyScrollLockEnabled;

      if (!bodyScrollLockEnabled) {
        return;
      }

      bodyScrollLockEnable({
        allowTouchMove: function allowTouchMove(el) {
          return Boolean(el.closest('div.modal-wrapper-lock'));
        }
      });
    }
  }, {
    key: "_unlockBodyScroll",
    value: function _unlockBodyScroll() {
      var _this$props3 = this.props,
          bodyScrollLockDisable = _this$props3.bodyScrollLockDisable,
          bodyScrollLockEnabled = _this$props3.bodyScrollLockEnabled;

      if (!bodyScrollLockEnabled) {
        return;
      }

      bodyScrollLockDisable();
    }
  }, {
    key: "_subscribeToEscKey",
    value: function _subscribeToEscKey() {
      var _this2 = this;

      var escKeyListenSubscribe = this.props.escKeyListenSubscribe;

      if (this.props.closeOnEsc) {
        this._escKeySubscription = escKeyListenSubscribe(function () {
          if (_this2.props.closeOnEsc && _this2.props.onClose) {
            _this2.props.onClose();
          }
        });
      }
    }
  }, {
    key: "_unsubscribeFromEscKey",
    value: function _unsubscribeFromEscKey() {
      if (this._escKeySubscription) {
        this._escKeySubscription.unsubscribe();

        delete this._escKeySubscription;
      }
    }
  }, {
    key: "_createFocusTrap",
    value: function _createFocusTrap() {
      // We don't care about focus traps when FixedSticky portal workaround is enabled, because:
      // - it is enabled on iOS only, and focus traps aren't useful for Modal on mobile anyway
      // - it causes FixedSticky elements to be non-clickable
      //   (in Portal workaround FixedSticky renders its child directly in the document.body,
      //    so even if it's part of the Modal, it's not part of its' DOM tree).
      if (isFixedStickyPortalWorkaroundEnabled()) {
        return;
      }

      if (this._focusTrap) {
        return;
      }

      if (!this._wrapperRef.current || !this._outerRef.current) {
        return;
      }

      this._focusTrap = focusTrap_1(this._wrapperRef.current, {
        initialFocus: this._outerRef.current,
        fallbackFocus: this._outerRef.current
      });

      this._focusTrap.activate();
    }
  }, {
    key: "_removeFocusTrap",
    value: function _removeFocusTrap() {
      if (this._focusTrap) {
        this._focusTrap.deactivate();

        delete this._focusTrap;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          ariaLabel = _this$props4.ariaLabel,
          backdrop = _this$props4.backdrop,
          transitionDuration = _this$props4.transitionDuration,
          children = _this$props4.children,
          open = _this$props4.open,
          verticalAlign = _this$props4.verticalAlign,
          debug = _this$props4.debug,
          paddingTop = _this$props4.paddingTop,
          paddingBottom = _this$props4.paddingBottom,
          width = _this$props4.width,
          height = _this$props4.height,
          bodyScrollLockEnabled = _this$props4.bodyScrollLockEnabled;
      var _this$state = this.state,
          showModal = _this$state.showModal,
          zIndex = _this$state.zIndex;
      var _handleModalTransitionEnter = this._handleModalTransitionEnter,
          _handleModalTransitionEntering = this._handleModalTransitionEntering,
          _handleModalTransitionExit = this._handleModalTransitionExit,
          _handleModalTransitionExited = this._handleModalTransitionExited,
          _handleBackdropClick = this._handleBackdropClick,
          isFullScreen = this._isFullScreen,
          _wrapperRef = this._wrapperRef,
          _dialogBeforeRef = this._dialogBeforeRef,
          _dialogAfterRef = this._dialogAfterRef,
          _outerRef = this._outerRef,
          _innerRef = this._innerRef;
      return showModal && /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(Transition, {
        "in": open,
        appear: true,
        timeout: transitionDuration,
        onEnter: _handleModalTransitionEnter,
        onEntering: _handleModalTransitionEntering,
        onExit: _handleModalTransitionExit,
        onExited: _handleModalTransitionExited
      }, /*#__PURE__*/React.createElement("div", {
        ref: _wrapperRef,
        className: bodyScrollLockEnabled ? 'modal-wrapper-lock' : 'modal-wrapper'
      }, /*#__PURE__*/React.createElement("div", {
        ref: _dialogBeforeRef
      }), /*#__PURE__*/React.createElement(ModalWrapperContext.Provider, {
        value: this._ModalWrapperContextValue
      }, /*#__PURE__*/React.createElement(StyledModalContainer, {
        className: "sessioncammonitorscroll",
        zIndex: zIndex,
        fullScreen: isFullScreen,
        ref: _outerRef,
        tabIndex: -1,
        role: "dialog",
        "aria-label": ariaLabel || 'Modal',
        "data-testid": ModalContainer.selector(ariaLabel)
      }, backdrop && !isFullScreen && /*#__PURE__*/React.createElement(StyledBackdrop, {
        zIndex: zModalMouseBackdrop(zIndex),
        debug: debug,
        onClick: _handleBackdropClick
      }), /*#__PURE__*/React.createElement(StyledModalContainerInner, {
        ref: _innerRef,
        fullScreen: isFullScreen,
        zIndex: zModalInner(zIndex),
        verticalAlign: verticalAlign
      }, /*#__PURE__*/React.createElement(StyledModalContainerInner2, {
        fullScreen: isFullScreen,
        zIndex: zModalInner2(zIndex)
      }, backdrop && !isFullScreen && /*#__PURE__*/React.createElement(StyledInner2Backdrop, {
        zIndex: zModalInner2MouseBackdrop(zIndex),
        debug: debug,
        onClick: _handleBackdropClick
      }), /*#__PURE__*/React.createElement(StyledModalContainerInner3, {
        zIndex: zModalInner3(zIndex),
        width: width,
        height: height,
        verticalAlign: verticalAlign,
        marginTop: paddingTop,
        marginBottom: paddingBottom
      }, /*#__PURE__*/React.createElement(ZIndexContext.Provider, {
        value: zModalInner3(zIndex)
      }, children)))))), /*#__PURE__*/React.createElement("div", {
        ref: _dialogAfterRef
      }))));
    }
  }]);

  return ModalContainerWithContextsProvided;
}(React.PureComponent);
ModalContainerWithContextsProvided._zIndexCounter = zModalBase;

export { ModalContainer, ModalContainerWithContextsProvided };
